
import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneObjective({ content, icon, description }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	
	return (
		<div
  className="mShadow1 bg-light"
  style={{
    height: "auto",
    position: 'relative',
    overflow: "hidden",
    borderRadius: "12px",
    border: "2px solid var(--lightColor)",
    marginBottom: "16px",
    padding: "16px",
  }}
>
  <div
    style={{
      display: "flex",
      gap: "12px",
      alignItems: "center",
      marginBottom: "12px",
    }}
  >
    {icon && (
      <div
        className="text-muted"
        style={{
          width: "56px",
          height: "56px",
          borderRadius: "6px",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <div style={{ fontSize: "16px", lineHeight: 1 }}>
          {icon}
        </div>
      </div>
    )}

    <div
      className="font-semi-bold text-primary"
      style={{
        fontSize: "18px",
        lineHeight: "1.4",
      }}
    >
      {content}
    </div>
  </div>

  <hr
    style={{
      borderColor: "rgba(0, 0, 0, 0.08)",
      margin: "8px 0",
    }}
  />

  <div
    className="text-muted"
    style={{
      fontSize: "14px",
      lineHeight: "1.5",
      marginTop: "8px",
    }}
  >
    {description}
  </div>
</div>
	)
	

	
}
